import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing.unit,
  },
});

class CartaSocialBadge extends React.Component {
  state = {
    anchorEl: null,
  };

  constructor() {
    super();
    this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
    this.handlePopoverClose = this.handlePopoverClose.bind(this);
  }

  handlePopoverOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { cartaSocial } = this.props;
    return (
      <>
        {cartaSocial ? (
          <>
            <Tooltip title="Carta Social">
              <Avatar
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                className="social_charter-avatar"
                onMouseEnter={this.handlePopoverOpen}
                onMouseLeave={this.handlePopoverClose}
              >
                CS
              </Avatar>
            </Tooltip>
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default withStyles(styles)(CartaSocialBadge);
